/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PermissionKind {
    ADMIN_ACCESS = 'AdminAccess',
    MANAGE_SETTINGS = 'ManageSettings',
    MANAGE_USERS = 'ManageUsers',
    MANAGE_ROLES = 'ManageRoles',
    MANAGE_PROJECT_ACCESS = 'ManageProjectAccess',
    CREATE_PROJECT = 'CreateProject',
    PROJECT_VIEW = 'ProjectView',
    PROJECT_EDIT = 'ProjectEdit',
    HISTORY_VIEW = 'HistoryView',
    HISTORY_RESTORE = 'HistoryRestore',
    COMMENT_VIEW = 'CommentView',
    COMMENT_CREATE = 'CommentCreate',
    COMMENT_EDIT = 'CommentEdit',
    COMMENT_DELETE = 'CommentDelete',
}
